import { Scrollbar } from 'react-scrollbars-custom'
import Achievement from '../../../../features/achiev'
import useFilteredAchieves from '../../model/hooks/useFilteredAchieves'
import { useModal } from '../../../../../hooks/useModal'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import { useTranslation } from '../../../../../translations'
import numWord from '../../../../../utils/numWord'
import { IMAGE, TEXT } from '../../../../modals/universalModal'
import content from '../../constants/content'
import { gtmFunctions } from '../../../../../constants/analytics/GTM'

const {
  forFriendAchievementsModal: {
    components: [title, buttons],
    modalProps,
  },
} = content

const CURRENT_TIMESTAMP = Math.floor(Date.now() / 1000)

export default function AchievesList() {
  const filteredAchieves = useFilteredAchieves()
  const { addModal } = useModal()
  const { t } = useTranslation()
  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties')
  const variants = {
    beauties: [
      t('other.beautiesVariants.text1'),
      t('other.beautiesVariants.text2'),
      t('other.beautiesVariants.text3'),
    ],
    gifts: [
      t('other.giftVariants.text1'),
      t('other.giftVariants.text2'),
      t('other.giftVariants.text3'),
    ],
  }
  const actualAchieves = filteredAchieves.filter(({ quest_end_at }) => {
    if (!quest_end_at) return true

    const endAt = Number(quest_end_at)
    if (Number.isNaN(endAt)) return true

    return CURRENT_TIMESTAMP <= endAt
  })

  const clickOnAchievement = (item) => {
    if (item.progress >= item.quest_trigger_count) return
    const rewardValue = gameTamagotchiBeauties ? item.prize?.beauties : item.prize?.gacha_event_cash
    const rewardAmount = Number(rewardValue)
    const rewardVariants = gameTamagotchiBeauties ? variants.beauties : variants.gifts
    const rewardComponent =
      rewardValue === null || rewardValue === undefined
        ? null
        : {
            type: TEXT,
            props: {
              value: `${rewardAmount} ${numWord(rewardAmount, rewardVariants)}`,
            },
          }

    gtmFunctions.GTMAchievements({ name: item?.title })

    addModal({
      type: 'universalModal',
      props: {
        modalProps,
        components: [
          {
            list: [
              {
                type: IMAGE,
                props: {
                  img: item.prize?.image,
                  modifier: 'min-width',
                },
              },
              title,
              ...(rewardComponent ? [rewardComponent] : []),
              {
                type: TEXT,
                props: {
                  isUseTranslation: false,
                  value: item.modal_description,
                },
              },
              buttons,
            ],
          },
        ],
      },
    })
  }

  return (
    <div className={'challenges__block'}>
      {/*<div className={`challenges__text`}>{safeHTML(ach.text)}</div>*/}
      <Scrollbar>
        <div className={'challenges__list challenges__list_achievements'}>
          {actualAchieves?.map((achievement) => (
            <Achievement
              key={achievement.system_name}
              className={'challenges__achievement'}
              onClick={() => clickOnAchievement(achievement)}
              isVisibleProgress={true}
              {...achievement}
            />
          ))}
        </div>
      </Scrollbar>
    </div>
  )
}
